import React from 'react';
import get from 'lodash/get';
import Image from 'next/future/image';

import { ICategory } from '@/models';

interface Props {
  category: ICategory;
  data: ICategory;
}

const CategoryCard: React.FC<Props> = ({ category, data }) => {
  // const image = get(
  //   category,
  //   `subcategories-images.${data.id_category}`,
  //   '/v2/category/category.jpg'
  // );
  const image = '/v2/category/category.jpg';

  return (
    <li className="relative bg-primary">
      <Image
        src={image}
        alt={data.category_name}
        width={0}
        height={0}
        sizes="100vw"
        className="object-contain w-full h-full"
      />

      <div className="absolute inset-0 p-4 md:p-8">
        <div className="text-white break-words h3">{data.category_name}</div>
      </div>
    </li>
  );
};

export default CategoryCard;
